import { render, staticRenderFns } from "./TableButtonsEditMoveRotate.vue?vue&type=template&id=67a4f3ae&scoped=true&"
import script from "./TableButtonsEditMoveRotate.vue?vue&type=script&lang=js&"
export * from "./TableButtonsEditMoveRotate.vue?vue&type=script&lang=js&"
import style0 from "./TableButtonsEditMoveRotate.vue?vue&type=style&index=0&id=67a4f3ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a4f3ae",
  null
  
)

export default component.exports